import { BaseAPICallsHandler } from "../NetworkClient/BaseAPICallsHandler";
import { ServerConfig } from "../NetworkClient/ServerConfig";
import { GenieChatResponse, GenieChatTurn } from "./genieTypes";

export class GenieService {
  public static shared = new GenieService();

  private apiHandler = BaseAPICallsHandler.shared;
  private serverConfig = ServerConfig.shared;

  public async chat(messages: GenieChatTurn[]): Promise<GenieChatResponse> {
    const url = this.serverConfig.genieAPIs.chatAPI;
    const response = await this.apiHandler.makePostRequest({}, url, { messages });
    return response.data as GenieChatResponse;
  }
}
